import React from "react";
import PropTypes from "prop-types";

// import store
import { connect } from "react-redux";
import { setFormation } from "../../store/actions";

// import deep-equal
import equal from "deep-equal";

class Formations extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { formations } = this.props;

    return (
      <React.Fragment>
        <div className="row justify-content-cent">
          <div className="col-8">
            <p className="p-3  m-0">Formations</p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
Formations.propTypes = {
  formations: PropTypes.object,
  onSetFormations: PropTypes.func,
};
const mapStateToProps = (state) => ({
  formations: state.formations,
});
const mapDispatchToProps = (dispatch) => ({
  onSetFormations: (data) => dispatch(setFormation(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Formations);
